module.exports = __webpack_public_path__ + "img/brands-mulino-commitment.jpg?8beb7e20931e6d55a162233f51c92924";